module.exports = __webpack_public_path__ + "static/media/championRabbit_800.0ac3062a.png";